import { render, staticRenderFns } from "./ProductDetailForm.vue?vue&type=template&id=b7e56e2a&scoped=true&"
import script from "./ProductDetailForm.vue?vue&type=script&lang=js&"
export * from "./ProductDetailForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailForm.vue?vue&type=style&index=0&id=b7e56e2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e56e2a",
  null
  
)

export default component.exports